import { MQ_MIN_MEDIUM } from '@app/theme/types';
import { css } from '@emotion/react';

export const customReportsToolsStyles = () =>
  css({
    display: 'flex',
    justifyContent: 'space-between',
    justifyItems: 'center',
    gap: '8px',
    marginBottom: '5px',
    '.insert': {
      height: '30px',
    },
    '> div': {
      gap: '7px',
      'button.tool': {
        width: '40px',
        height: '30px',
      },
    },
    [MQ_MIN_MEDIUM]: {
      '.insert': {
        height: '50px',
      },
      '> div': {
        'button.tool': {
          width: '50px',
          height: '50px',
        },
      },
    },
  });
